export default __webpack_public_path__ + "static/mac-cc-ab17ac518e44f7a9a90ed509605b235a.mp4";